export const moduleType = {
  'ESAI LENGTH': 'orange.1',
  'PILIHAN GANDA': 'background.2',
  'ENUM (YA/TIDAK)': 'background.2',
  'PILIHAN A/B': 'background.4',
  'PILIH SALAH SATU': 'background.2',
  'PILIHAN ANGKA': 'background.4',
}

export const modulesType = {
  ESSAY_LENGTH: 'ESAI LENGTH',
  MULTIPLE: 'PILIHAN GANDA',
  ENUM: 'ENUM (YA/TIDAK)',
  MULTIPLE_AB: 'PILIHAN A/B',
  ESSAY: 'ESSAI',
  PG: 'PG',
  DISC: 'PILIH SALAH SATU',
  ESAI_FREE_TEXT: 'ESAI FREE TEXT',
  SOAL_ONLY: 'SOAL ONLY',
  DESCRIPTION_ONLY: 'DESCRIPTION ONLY',
  NUMBER_CHOICE: 'PILIHAN ANGKA',
}

export const moduleTypeIncludes = Object.values(modulesType)
